import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-field', 'required', 'Privaloma');
Labels.set('ui-field', 'add', 'Pridėti');
Labels.set('ui-field', 'remove', 'Ištrinti');
